'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';
import { AuditEvent } from '../../types';

interface AuditEventDetailsProps {
  event: AuditEvent;
}

export function AuditEventDetails({ event }: AuditEventDetailsProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Audit Event Details</Title>
      <Text c="dimmed" size="sm">Event details viewer coming soon</Text>
    </Paper>
  );
}